import PropTypes from 'prop-types';
import CONSTANTS from '@helpers/constant';
import styles from './campaign-type-group.module.scss';

const campaignOptions = [
  {
    label: 'Dynamic Coupon',
    tag: 'Recommended for all businesses',
    badge: 'New',
    subtitle:
      'Create targeted discount coupons based on customer spend and visit patterns. Control offer value, redemption windows, and budget limits from your dashboard.',
    value: CONSTANTS.DC_GAME_TYPE,
    device: '/images/campaign_dc_Info.webp',
    example: '"Spend £10+ between 2–5pm next week and get £3 off."',
    highlights: [
      'Target by spend amount and visit frequency',
      'Set daily and total coupon limits to control budget',
      'Choose delivery — print receipt or mobile wallet',
      'Schedule campaigns with start and end dates',
      'Real-time analytics on transactions and redemptions',
    ],
  },
  {
    label: 'Nominate Loyalty',
    tag: 'Coffee shops, food-to-go, salons & more',
    subtitle:
      'Run a digital stamp card program directly from your terminal. Set minimum spend thresholds, stamp count, and reward value — everything runs automatically.',
    value: CONSTANTS.NOM_GAME_TYPE,
    device: '/images/campaign_nom_Info.webp',
    example: '"Spend £5 or more, 8 times, and get £5 off."',
    highlights: [
      'Set minimum spend to lift average basket size',
      'Rewards issued automatically — no staff training needed',
      'Track participation and redemption in real-time',
      'Configure stamp count and reward value per campaign',
      'View per-stamp analytics and completion rates',
    ],
  },
  {
    label: 'Win Loyalty',
    tag: 'Restaurants, boutique retail & beauty',
    subtitle:
      'Add a pick-a-card game to your checkout flow. Configure four reward tiers with different values, minimum spends, and validity windows to drive return visits.',
    value: CONSTANTS.WIN_GAME_TYPE,
    device: '/images/campaign_win_Info.webp',
    example: '"Save £10 on weekday lunch. Min spend £50. Valid Mon–Thu."',
    highlights: [
      'Configure four reward tiers with custom values',
      'Set minimum spend per reward to protect margins',
      'Restrict redemption to specific days and time slots',
      'Track issuance and redemption per reward tier',
      'Clone and relaunch campaigns with one click',
    ],
  },
];

function PLCampaignTypeGroup({ onChange, highlightedType }) {
  return (
    <div className={styles.container}>
      {campaignOptions.map(option => (
        <div
          key={option.value}
          id={`campaign-card-${option.value}`}
          className={`${styles.card} ${highlightedType === option.value ? styles.highlighted : ''}`}
        >
          <div className={styles.imageSection}>
            {option.badge && <span className={styles.featureBadge}>{option.badge}</span>}
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={option.device} alt={option.label} />
          </div>
          <div className={styles.contentSection}>
            <span className={styles.tag}>{option.tag}</span>
            <h3 className={styles.title}>{option.label}</h3>
            <p className={styles.description}>{option.subtitle}</p>
            <ul className={styles.highlights}>
              {option.highlights.map(item => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p className={styles.example}>
              <span className={styles.exampleLabel}>Example:</span> {option.example}
            </p>
            <div className={styles.actions}>
              <button
                type="button"
                className={styles.createBtn}
                onClick={() => onChange?.(option.value)}
              >
                Create Campaign
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

PLCampaignTypeGroup.propTypes = {
  onChange: PropTypes.func,
  highlightedType: PropTypes.string,
};

export default PLCampaignTypeGroup;
